import { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import GymSidebar from "./GymSidebar";
import GymContent from "./GymContent";
import SEOHelmet from "../../../Components/SeoHelmet";

export default function Gyms() {
  // استیت‌های مربوط به فیلترها (تبدیل به آبجکت برای Autocomplete)
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [isDiscount, setIsDiscount] = useState(undefined);

  // آماده‌سازی پارامترها برای ارسال به API با استفاده از Optional Chaining
  const queryParams = {
    search: searchQuery || undefined,
    sport: selectedSport?._id || undefined,
    province: selectedProvince?._id || undefined,
    city: selectedCity?._id || undefined,
    area: selectedArea?._id || undefined,
    isDiscount,
  };

  return (
    <>
      <SEOHelmet
        title="لیست بهترین باشگاه‌های ورزشی | آدین زون"
        description="جستجو و مشاهده لیست برترین باشگاه‌های ورزشی ویژه بانوان و آقایان. امکانات رفاهی، گالری تصاویر، نظرات کاربران و تعرفه‌ها را در آدین زون بررسی کنید."
        keywords="لیست باشگاه های ورزشی, بهترین باشگاه بدنسازی, باشگاه ورزشی بانوان, رزرو باشگاه, ثبت نام باشگاه, باشگاه در مشهد"
        author="AdinZone"
      />
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          bgcolor: "background.default",
          py: { xs: 4, sm: 6, md: 8 },
          px: { xs: 1.5, sm: 2, md: 3, lg: 4, xl: 6 },
        }}
      >
        <Container
          maxWidth="xxl"
          sx={{
            px: { xs: 1, sm: 2, md: 3, lg: 4 },
          }}
        >
          {/* Header */}
          <Box component="header" sx={{ my: { xs: 3, sm: 4, md: 5, lg: 2 } }}>
            <Typography
              component="h1"
              variant="h4"
              fontWeight={800}
              sx={{
                background: "linear-gradient(135deg, #5c6bc0 0%, #8c9eff 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
                mb: 1,
                fontSize: {
                  xs: "1.5rem",
                  sm: "1.75rem",
                  md: "2rem",
                  lg: "2.25rem",
                },
              }}
            >
              باشگاه‌های ورزشی
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: { xs: "0.75rem", sm: "0.875rem" } }}
            >
              بهترین باشگاه‌های شهر خود را پیدا و مقایسه کنید
            </Typography>
          </Box>

          {/* Main layout */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "220px 1fr",
                lg: "260px 1fr",
                xl: "300px 1fr",
              },
              gap: { xs: 2, sm: 2.5, md: 3 },
            }}
          >
            {/* سایدبار */}
            <GymSidebar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              selectedSport={selectedSport}
              setSelectedSport={setSelectedSport}
              selectedProvince={selectedProvince}
              setSelectedProvince={setSelectedProvince}
              selectedCity={selectedCity}
              setSelectedCity={setSelectedCity}
              selectedArea={selectedArea}
              setSelectedArea={setSelectedArea}
              isDiscount={isDiscount}
              setIsDiscount={setIsDiscount}
            />

            {/* محتوا */}
            <GymContent queryParams={queryParams} />
          </Box>
        </Container>
      </Box>
    </>
  );
}
